import { NodeSpec } from 'prosemirror-model';

/**
 * Bibliography node - automatically generates and updates reference list
 * 
 * This is a special block node that:
 * - Scans document for all citation marks
 * - Generates formatted bibliography entries
 * - Auto-updates when citations are added/removed
 */
export const bibliographyNodeSpec: NodeSpec = {
  group: 'block',
  content: '',  // Empty - content is generated by nodeView
  atom: true,   // Can't edit content directly
  selectable: true,  // Can be selected and deleted
  attrs: {
    id: { default: null },
    citationStyle: { default: 'apa' },
    autoUpdate: { default: true },
    showTitle: { default: true },
    title: { default: 'References' }
  },
  
  parseDOM: [{
    tag: 'div[data-bibliography]',
    getAttrs: (dom: HTMLElement | string) => {
      if (typeof dom === 'string') return false;
      return {
        id: dom.getAttribute('data-bib-id'),
        citationStyle: dom.getAttribute('data-citation-style') || 'apa',
        autoUpdate: dom.getAttribute('data-auto-update') !== 'false',
        showTitle: dom.getAttribute('data-show-title') !== 'false',
        title: dom.getAttribute('data-title') || 'References'
      };
    }
  }],
  
  toDOM(node) {
    return [
      'div',
      {
        'data-bibliography': 'true',
        'data-bib-id': node.attrs.id,
        'data-citation-style': node.attrs.citationStyle,
        'data-auto-update': String(node.attrs.autoUpdate),
        'data-show-title': String(node.attrs.showTitle),
        'data-title': node.attrs.title,
        'class': 'bibliography-section'
      }
    ];
  }
};

